import {mapGetters, mapActions} from 'vuex'
export const initPage = {
    data() {
        return {}
    },
    created() {
        this.setPage({page: 1, pageSize: this.page.pageSize})
    },
    methods: {
        ...mapActions([
            'setPage'
        ])
    },
    watch: {},
    computed: {
        ...mapGetters(['page'])
    }
}
